export default __webpack_public_path__ + "static/media/evergreen-meadow.008ed147.png";